import { render, staticRenderFns } from "./HeatmapType.vue?vue&type=template&id=1cf49280"
import script from "./HeatmapType.vue?vue&type=script&lang=js"
export * from "./HeatmapType.vue?vue&type=script&lang=js"
import style0 from "./HeatmapType.vue?vue&type=style&index=0&id=1cf49280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports